import React from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import { FaqList } from './FaqList';
import s from './FaqSection.scss';
export const FaqSection = ({ title, subtitle, faq, onClickFaqItem, }) => {
    return (React.createElement(Box, { background: "#f3f6f9", align: "center", width: "100%" },
        React.createElement(Box, { className: s.faqContainer, align: "space-between", verticalAlign: "top", maxWidth: "1140px", width: "100%" },
            React.createElement(Box, { className: s.faqTitleContainer, direction: "vertical" },
                React.createElement(Heading, { className: s.faqTitle, appearance: "H2" }, title),
                React.createElement(Text, { weight: "normal", size: "medium", tagName: "p" }, subtitle)),
            React.createElement(FaqList, { faq: faq, onClickFaqItem: onClickFaqItem }))));
};
//# sourceMappingURL=FaqSection.js.map